/*--------------COLLECTION PAGE JS----------------*/
/*---------Woohoo! You've found the mini maze of JS! Don't get lost in the shrunk code jungle!-----------*/
// Define Shopify object and formatMoney function
window.Shopify = window.Shopify || {};
let overlay = null;
window.currentView = "grid";
window.currentPage = 1;
Shopify.formatMoney = function (cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const formatString = format || moneyFormat;
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return "0";
    }
    number = (number / 100.0).toFixed(precision);
    const parts = number.split(".");
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    const cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)?.[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};

(window.marmeto = window.marmeto || {}),
  (marmeto.Collection = (function () {
    var t = "#js-product-loop",
      e = "#js-empty-products",
      a = "#js-pagination-holder",
      r = "#js-products-count",
      i = "#sidebar-filter",
      s = "#js-sort-mobile";
    let coun = 0;
    // Define moneyFormat variable with default Indian Rupee format
    const moneyFormat = "₹{{amount_no_decimals}}";
    function o(t) {
      if (
        ((this.container = document.querySelector(
          '[data-section-type="' + t + '"]'
        )),
        this.container)
      ) {
        if (
          ((this.productsPerAjax = 100),
          (this.allProducts = []),
          (this.totalPage = ""),
          (this.params = {
            page: 1,
            q: void 0,
            filterOptions: void 0,
            sortBy: void 0,
          }),
          (this.customFilters = this.initCustomFilters()),
          this.toggleProductGridView(),
          (this.options = JSON.parse(
            this.container.getAttribute("data-section-settings")
          )),
          (this.sectionId = this.container.getAttribute("data-section-id")),
          history &&
            history.state &&
            history.state.filterOptions &&
            history.state.filterOptions.price)
        ) {
          var e = history.state.filterOptions.price[0];
          (document.querySelector(".price-filter-item").dataset.tag = e),
            (document.querySelector('[name="PriceFilterMin"]').value =
              e.split("-")[0]),
            (document.querySelector('[name="PriceFilterMax"]').value =
              e.split("-")[1]);
        }
        this.initQueryFromUrl(),
          this.initCollection(),
          this.attachEventListeners();
      }
    }
    return (
      (o.prototype.attachEventListeners = function () {
        var t = this,
          e = document.querySelectorAll(".filter-item");
        for (var r of e)
          r.addEventListener("click", function () {
            this.classList.toggle("filter-selected");
            let e = $(this),
              a = $(this),
              r = $(
                `.sticky-top-filter-container[data-top-filters='${e.attr(
                  "data-tag"
                )}']`
              );
            a && a.toggleClass("filter-active"),
              r && r.toggleClass("sticky-round-filters-active"),
              t.handleFilterChange(),
              document.dispatchEvent(
                new CustomEvent("swym:collections-loaded")
              ),
              document.dispatchEvent(
                new CustomEvent("Flits:Mammeto-Collections-Loaded")
              ),
              document
                .querySelector(".mmc-container")
                .scrollIntoView({ behavior: "smooth" });
          });

        var o = document.querySelectorAll(".clear-all");
        for (var n of o)
          n.addEventListener("click", function (e) {
            e.preventDefault(),
              document.querySelectorAll(".filter-item").forEach(function (t) {
                t.classList.remove("filter-selected");
              }),
              document
                .querySelectorAll(".top-filter-container")
                .forEach((c) => {
                  c.classList.remove("filter-active");
                });
            t.handleFilterChange();
            document.dispatchEvent(
              new CustomEvent("Flits:Mammeto-Collections-Loaded")
            );
          });
        var l = document.querySelectorAll("#js-sort-desktop li");

        // Highlight the selected sort option on page load
        l.forEach((el) => {
          var a = el.getAttribute("data-value");
          if (a === t.params.sortBy) {
            el.querySelector(".sort-checkbox").classList.add("is-selected");
          } else {
            el.querySelector(".sort-checkbox").classList.remove("is-selected");
          }
        });

        // Set up click listeners
        for (var c of l) {
          c.addEventListener("click", function (e) {
            e.preventDefault();

            const checkbox = this.querySelector(".sort-checkbox");
            const isSelected = checkbox.classList.contains("is-selected");

            if (isSelected) {
              // Remove selection
              checkbox.classList.remove("is-selected");

              // Remove sort_by from t.params and URL
              const url = new URL(window.location.href);
              url.searchParams.delete("sort_by");
              history.replaceState(null, "", url.toString());
              t.params.sortBy = null;
              //  Refresh product list
              t.getProducts(t.params.page);
              t.handleFilterChange();

              return;
            }

            // If new selection made
            const value = this.getAttribute("data-value");
            t.params.sortBy = value;

            // Update URL with new sort_by
            const url = new URL(window.location.href);
            url.searchParams.set("sort_by", value);
            history.replaceState(null, "", url.toString());

            // Apply sorting and refresh
            t.getProducts(t.params.page);
            t.handleFilterChange();

            // Toggle selected style
            l.forEach((el) =>
              el.querySelector(".sort-checkbox").classList.remove("is-selected")
            );
            checkbox.classList.add("is-selected");

            // Fire custom events
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            document.dispatchEvent(
              new CustomEvent("Flits:Mammeto-Collections-Loaded")
            );
          });
        }

        var d = document.querySelectorAll("#js-sort-mobile li");
        for (var p of d)
          p.addEventListener("click", function (e) {
            e.preventDefault();
            var a = this.getAttribute("data-value");
            (t.params.sortBy = a),
              t.getProducts(t.params.page),
              t.handleFilterChange(),
              document.querySelector(s).classList.remove("is--opened"),
              document.dispatchEvent(
                new CustomEvent("swym:collections-loaded")
              );

            document.dispatchEvent(
              new CustomEvent("Flits:Mammeto-Collections-Loaded")
            );
            $("body").removeClass("no-scroll");
          });
        var u = document.querySelectorAll(".js-accordion-heading");
        for (var h of u)
          h.addEventListener("click", function (e) {
            e.preventDefault(),
              this.classList.toggle("is-closed"),
              t.helpers().slideToggle(this.nextElementSibling);
          });
        document.querySelector(a).addEventListener("click", function (e) {
          e.preventDefault();
          var a = "";
          "A" === e.target.tagName
            ? (a = e.target.getAttribute("data-page"))
            : ("svg" !== e.target.tagName && "path" !== e.target.tagName) ||
              (a = e.target.closest("a").getAttribute("data-page")),
            t.helpers().scrollToTop(),
            "" === a && (a = "999"),
            "999" !== a && (a = parseInt(a)),
            a != t.params.page &&
              ((t.params.page = a), t.pushState(), t.getProducts(a));
          document.dispatchEvent(
            new CustomEvent("Flits:Mammeto-Collections-Loaded")
          );
          window.currentPage = a;
        }),
          document
            .querySelector('[data-action="open-filter"]')
            .addEventListener("click", function () {
              document
                .querySelector(".mmc-main__filter")
                .classList.add("is--opened"),
                document.querySelector(s).classList.contains("is--opened") &&
                  document.querySelector(s).classList.remove("is--opened");
              $("body").addClass("no-scroll");

              if (!overlay) {
                overlay = document.createElement("div");
                overlay.id = "nav-overlay";
                overlay.className = "tw-fixed  !tw-flex tw-inset-0";
                document.body.appendChild(overlay);
              }
              document
                .getElementById("nav-overlay")
                ?.addEventListener("click", () => {
                  document
                    .querySelector(".mmc-main__filter")
                    .classList.remove("is--opened");
                  document.body.classList.remove("no-scroll");
                  overlay.remove(); // Remove overlay from DOM
                  overlay = null;
                });
            });

        var m = document.querySelectorAll('[data-action="close-filter"]');
        for (var v of m)
          v.addEventListener("click", function () {
            overlay.remove();
            overlay = null;
            document
              .querySelector(".mmc-main__filter")
              .classList.remove("is--opened");
            $("body").removeClass("no-scroll");
          });
        document
          .querySelector('[data-action="open-sort"]')
          .addEventListener("click", function () {
            document.querySelector(s).classList.toggle("is--opened"),
              $("body").toggleClass("no-scroll");
          });
        var f = document.querySelector('[name="PriceFilterMin"]'),
          y = document.querySelector('[name="PriceFilterMax"]');
        null != document.querySelector('[name="PriceFilterMin"]') &&
          document
            .querySelector('[name="PriceFilterMin"]')
            .addEventListener("change", function (e) {
              (e.target.value = Math.max(
                Math.min(
                  parseInt(e.target.value),
                  parseInt(y.value || e.target.max) - 1
                ),
                e.target.min
              )),
                e.target.value,
                parseInt(y.value || e.target.max),
                t.handleFilterChange();
            }),
          null != document.querySelector('[name="PriceFilterMax"]') &&
            document
              .querySelector('[name="PriceFilterMax"]')
              .addEventListener("change", function (e) {
                (e.target.value = Math.min(
                  Math.max(
                    parseInt(e.target.value),
                    parseInt(f.value || e.target.min) + 1
                  ),
                  e.target.max
                )),
                  parseInt(f.value || e.target.min),
                  e.target.value,
                  t.handleFilterChange();
              });
      }),
      (o.prototype.initCollection = function () {
        var t = this,
          e = [],
          a = "",
          r = Math.ceil(this.options.productCount / this.productsPerAjax);
        this.params.sortBy && (a = "&sort_by=" + this.params.sortBy);

        for (var i = 1; i <= r; i++)
          e.push(fetch(location.pathname + "?view=json&page=" + i + a));

        if (e.length) {
          Promise.all(e).then(function (e) {
            Promise.all(
              e.map(function (t) {
                return t.text().then((text) => {
                  try {
                    return JSON.parse(text);
                  } catch {
                    return [];
                  }
                });
              })
            ).then(function (e) {
              allProductsCopy = e;
              for (var a = 0; a < e.length; a++)
                for (var r = e[a], i = 0; i < r.length; i++)
                  t.allProducts.push(r[i]);

              t.getProducts(t.params.page);

              //  Dispatch events
              document.dispatchEvent(
                new CustomEvent("swym:collections-loaded")
              );
              document.dispatchEvent(
                new CustomEvent("Flits:Mammeto-Collections-Loaded")
              );

              // Remove loader
              document
                .querySelector(".mmc-products")
                .classList.remove("loader");
            });
          });
        } else {
          console.error(
            "Nothing to fetch!! Either you forgot to add .json template or the current page type doesn't have any products."
          );
        }
      }),
      (o.prototype.getProducts = function (i) {
        var s = [],
          o = this.filterHelpers().filterProducts(
            this.allProducts,
            this.params.filterOptions
          );

        if (
          ((s = this.options.excludeOosProducts
            ? o.filter(function (t) {
                return t.available;
              })
            : o),
          (s = s.filter(function (t) {
            return (
              !t.tags ||
              !t.tags.includes("custom-dinner-set-item") ||
              !t.tags.includes("variant-main-product")
            );
          })),
          this.sortProducts(s),
          (this.totalPage = Math.ceil(s.length / this.options.productPerPage)),
          this.options.showOosLast &&
            s.sort(function (t, e) {
              return e.available - t.available;
            }),
          document.querySelector(r) &&
            (document.querySelector(r).innerHTML =
              "Showing " + s.length + " products"),
          s.length > 0 && i)
        ) {
          "999" !== i && i > this.totalPage && (i = 1);
          var n = "",
            l =
              s.length < i * this.options.productPerPage || "999" === i
                ? s.length
                : i * this.options.productPerPage,
            c =
              "999" === i || l < this.options.productPerPage
                ? 0
                : (i - 1) * this.options.productPerPage;

          // Create a document fragment to hold the product cards
          var fragment = document.createDocumentFragment();
          var tempDiv = document.createElement("div");

          for (; c < l; c++) {
            tempDiv.innerHTML = this.htmlRenderer().renderProduct(c, s[c]);
            while (tempDiv.firstChild) {
              fragment.appendChild(tempDiv.firstChild);
            }
          }

          this.generatePagination(i),
            document.querySelector(t).classList.remove("is-hidden"),
            document.querySelector(e).classList.add("is-hidden"),
            "infinite_scroll" == this.options.paginationType && 1 !== i
              ? document.querySelector(t).appendChild(fragment)
              : ((document.querySelector(t).innerHTML = ""),
                document.querySelector(t).appendChild(fragment));

          document.dispatchEvent(new CustomEvent("marmeto-filter-loaded"));
        } else
          (document.querySelector(t).innerHTML = ""),
            document.querySelector(t).classList.add("is-hidden"),
            document.querySelector(a).classList.add("is-hidden"),
            document.querySelector(e).classList.remove("is-hidden");
      }),
      (o.prototype.generatePagination = function (t) {
        var e = this;
        if (this.totalPage <= 1)
          document.querySelector(a).classList.add("is-hidden");
        else {
          var r = "";
          if (
            ("999" !== t &&
              (r +=
                (1 !== t
                  ? '<a href="' +
                    this.options.collectionUrl +
                    '?page=1" class="pagination__item" title="Navigate to page 1" data-page="1">1</a>'
                  : "") +
                (t >= 4 ? "…" : "") +
                (t - 2 > 1
                  ? '<a href="' +
                    this.options.collectionUrl +
                    "?page=" +
                    (t - 2) +
                    '" class="pagination__item" title="Navigate to page ' +
                    (t - 2) +
                    '" data-page="' +
                    (t - 2) +
                    '">' +
                    (t - 2) +
                    "</a>"
                  : "") +
                (t - 1 > 1
                  ? '<a href="' +
                    this.options.collectionUrl +
                    "?page=" +
                    (t - 1) +
                    '" class="pagination__item" title="Navigate to page ' +
                    (t - 1) +
                    '" data-page="' +
                    (t - 1) +
                    '">' +
                    (t - 1) +
                    "</a>"
                  : "") +
                '<span class="pagination__item pagination__item--current">' +
                t +
                "</span>" +
                (t + 1 < this.totalPage
                  ? '<a href="' +
                    this.options.collectionUrl +
                    "?page=" +
                    (t + 1) +
                    '" class="pagination__item" title="Navigate to page ' +
                    (t + 1) +
                    '" data-page="' +
                    (t + 1) +
                    '">' +
                    (t + 1) +
                    "</a>"
                  : "") +
                (t + 2 < this.totalPage
                  ? '<a href="' +
                    this.options.collectionUrl +
                    "?page=" +
                    (t + 2) +
                    '" class="pagination__item" title="Navigate to page ' +
                    (t + 2) +
                    '" data-page="' +
                    (t + 2) +
                    '">' +
                    (t + 2) +
                    "</a>"
                  : "") +
                (t <= this.totalPage - 4 ? "…" : "") +
                (t !== this.totalPage
                  ? '<a href="' +
                    this.options.collectionUrl +
                    "?page=" +
                    this.totalPage +
                    '" class="pagination__item" title="Navigate to page ' +
                    this.totalPage +
                    '" data-page="' +
                    this.totalPage +
                    '">' +
                    this.totalPage +
                    "</a>"
                  : "")),
            (r += '<div class="infinite-scroll-element"></div>'),
            (document.querySelector(a).innerHTML = r),
            "infinite_scroll" == this.options.paginationType)
          ) {
            document.querySelector(a).classList.add("is-hidden");
            let r = document.querySelector(".infinite-scroll-element");
            new IntersectionObserver((a) => {
              a[0].intersectionRatio <= 0 ||
                e.totalPage <= t ||
                e.getProducts(t + 1);
            }).observe(r);
          } else document.querySelector(a).classList.remove("is-hidden");
        }
      }),
      (o.prototype.initQueryFromUrl = function () {
        var t = this.helpers().generateQuery();
        t.q && (this.params.q = t.q),
          t.sort_by && (this.params.sortBy = t.sort_by),
          t.page && (this.params.page = parseInt(t.page)),
          this.params.q &&
            ((this.params.q = decodeURI(this.params.q)),
            this.filterHelpers().searchToFilter(this.params.q.split(",")),
            this.handleFilterChange()),
          this.params.filterOptions &&
            this.filterHelpers().setFilterOptions(this.params);
      }),
      (o.prototype.sortProducts = function (t) {
        var e = 0;
        return (
          "title-descending" == this.params.sortBy
            ? (e = function (t, e) {
                return e.title.localeCompare(t.title);
              })
            : "title-ascending" == this.params.sortBy
            ? (e = function (t, e) {
                return t.title.localeCompare(e.title);
              })
            : "price-ascending" == this.params.sortBy
            ? (e = function (a, b) {
                // Helper to get first available variant price
                const getFirstAvailablePrice = (product) => {
                  const availableVariant = product.variants.find(
                    (variant) => variant.available
                  );
                  return availableVariant
                    ? availableVariant.price
                    : product.price;
                };

                const priceA = getFirstAvailablePrice(a);
                const priceB = getFirstAvailablePrice(b);
                return priceA - priceB; // Ascending order
              })
            : "price-descending" == this.params.sortBy
            ? (e = function (t, e) {
                return e.price - t.price;
              })
            : "created-ascending" == this.params.sortBy
            ? (e = function (t, e) {
                return t.published_at > e.published_at
                  ? -1
                  : t.published_at == e.published_at
                  ? t.title.localeCompare(e.title)
                  : 1;
              })
            : "created-descending" == this.params.sortBy &&
              (e = function (t, e) {
                return e.published_at > t.published_at
                  ? 1
                  : e.published_at == t.published_at
                  ? e.title.localeCompare(t.title)
                  : -1;
              }),
          e ? t.sort(e) : t
        );
      }),
      (o.prototype.pushState = function () {
        var t = {},
          e = !1,
          a = location.pathname,
          r = new URLSearchParams();
        1 != this.params.page && ((t.page = this.params.page), (e = 1)),
          this.params.sortBy &&
            this.params.q &&
            ((t.sortBy = this.params.sortBy), (t.q = this.params.q), (e = 1)),
          this.params.q && ((t.q = this.params.q), (e = 1)),
          this.params.sortBy && ((t.sortBy = this.params.sortBy), (e = 1)),
          t.q && (t.q = decodeURI(t.q)),
          Object.keys(t).forEach(function (e) {
            r.append(e, t[e]);
          }),
          e && (a = "?" + r.toString()),
          history.pushState(
            { filterOptions: this.params.filterOptions },
            " ",
            a
          );
      }),
      (o.prototype.handleFilterChange = function () {
        const t = this;
        t.params.filterOptions = t.filterHelpers().fillFilter();

        if (t.params.page !== "999") {
          t.params.page = 1;
        }

        // Build the `q` parameter from the selected filters
        const allFilterValues = Object.values(t.params.filterOptions).flat();
        const uniqueFilters = [
          ...new Set(allFilterValues.map((v) => v.trim())),
        ];
        let qParam = uniqueFilters.join(",");
        // Construct the new URL
        let newPath = location.pathname;

        if (qParam) {
          newPath += `?q=${qParam}`;
          if (t.params.sortBy) {
            newPath += `&sort_by=${encodeURIComponent(t.params.sortBy)}`;
          }
        } else if (t.params.sortBy) {
          newPath += `?sort_by=${encodeURIComponent(t.params.sortBy)}`;
        }

        history.replaceState(t.params, "Filtered", newPath);

        this.updateActiveFilters();
      }),
      (o.prototype.bindRemoveFilterButtons = function () {
        const t = this;
        document.querySelectorAll(".remove-filter").forEach((button) => {
          button.addEventListener("click", function () {
            const clickedFilter = button.getAttribute("data-active-filter");

            // Remove filter-item with matching data-tag
            document.querySelectorAll(".filter-item").forEach((filterItem) => {
              if (
                filterItem.classList.contains("filter-selected") &&
                filterItem.getAttribute("data-tag") === clickedFilter
              ) {
                filterItem.classList.remove("filter-selected");
                filterItem.classList.remove("filter-active");
              }
            });

            // Remove from URL
            const url = new URL(window.location.href);
            let q = url.searchParams.get("q") || "";
            const filters = q
              .split(",")
              .filter((f) => f.trim() !== clickedFilter.trim());
            if (filters.length) {
              url.search = `?q=${filters.join(",")}`;
            } else {
              url.searchParams.delete("q");
            }
            window.history.replaceState({}, "", url);

            // Remove the button
            button.closest(".active-filters")?.remove();

            // Trigger updates
            t.handleFilterChange();
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            document.dispatchEvent(
              new CustomEvent("Flits:Mammeto-Collections-Loaded")
            );
            document
              .querySelector(".mmc-container")
              ?.scrollIntoView({ behavior: "smooth" });
          });
        });
      }),
      (o.prototype.updateActiveFilters = function () {
        const t = this;
        const activeFilterWrapper = document.querySelectorAll(
          ".active-filter-wrapper"
        );
        activeFilterWrapper.forEach((container) => {
          container.innerHTML = "";
        }); // Clear previous filters

        const currentUrl = new URL(window.location.href);
        const queryParam = currentUrl.searchParams.get("q");

        // Use Set to store unique trimmed filter values
        const activeFiltersSet = new Set();
        const activeFiltersLabelSet = new Set();

        // Add filters from URL
        if (queryParam) {
          queryParam.split(",").forEach((filter) => {
            const trimmed = filter.trim();
            if (trimmed) {
              activeFiltersSet.add(trimmed);
            }
          });
        }

        // Add filters from DOM
        const filterItem = document.querySelectorAll(
          ".filter-item.filter-selected"
        );
        const filterTypeItem = document.querySelectorAll(
          ".filter-item.filter-selected.filter-active"
        );

        [...filterItem, ...filterTypeItem].forEach((item) => {
          const tag = item.dataset.tag?.trim();
          const taglabel = item.dataset.label?.trim();
          if (tag) {
            activeFiltersSet.add(tag);
            activeFiltersLabelSet.add(taglabel);
          }
        });

        // Render unique filters
        const activeFilters = Array.from(activeFiltersSet);
        const activeFilterLabels = Array.from(activeFiltersLabelSet);

        // Render unique filters
        activeFilterLabels.forEach((label, index) => {
          const tag = activeFilters[index];
          activeFilterWrapper.forEach((container) => {
            container.innerHTML += `
            <div class="active-filters">
              ${label}
              <button data-active-filter="${tag}" class="remove-filter">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                  <path d="M17.4001 6.6L6.6001 17.4M6.6001 6.6L17.4001 17.4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>`;
          });
        });

        t.params.filterOptions = t.filterHelpers().fillFilter();
        t.params.q = Array.from(activeFiltersSet).join(",");
        if (t.params.page !== "999") {
          t.params.page = 1;
        }

        //  Update product grid
        t.getProducts(t.params.page);

        this.bindRemoveFilterButtons();
      }),
      (o.prototype.filterHelpers = function () {
        var t = this,
          e = document.querySelector(i);
        return {
          filterProducts: function (e, a) {
            var r = [];
            if (a && Object.keys(a).length)
              for (var i = 0; i < e.length; i++)
                t.helpers().productTagFilter(a, e[i]) && r.push(e[i]);
            else r = e;
            return r;
          },
          fillFilter: function () {
            var filterOptions = {};

            // Loop over each filter group with class `.and`
            document.querySelectorAll(".and").forEach(function (groupEl) {
              const tagKey = groupEl.getAttribute("data-tag");
              const selectedItems = groupEl.querySelectorAll(
                ".filter-item.filter-selected, .filter-item.filter-selected.filter-active"
              );

              const values = Array.from(selectedItems).map((item) =>
                t.helpers().getTagName(item)
              );

              if (values.length > 0) {
                filterOptions[tagKey] = values;
              }
            });

            return filterOptions;
          },
          searchToFilter: function (a) {
            document.querySelectorAll(".and", e).forEach(function (e) {
              e.querySelectorAll(".or").forEach(function (e) {
                -1 !== a.indexOf(t.helpers().getTagName(e)) &&
                  e.classList.add("filter-selected");
              });
            });
          },
          setFilterOptions: function (a) {
            document.querySelectorAll(".and", e).forEach(function (e) {
              var r = a[e.getAttribute("data-tag")];
              r &&
                r.length &&
                e.querySelectorAll(".or").forEach(function (e) {
                  r.indexOf(
                    t.helpers().handleize(e.getAttribute("data-tag")) ||
                      t.helpers().handleize(e.textContent).trim()
                  ) >= 0 && e.classList.add("filter-selected");
                });
            });
          },
        };
      }),
      (o.prototype.helpers = function () {
        var t = this;
        return {
          handleize: function (t) {
            return t
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "");
          },
          scrollToTop: function () {
            window.scrollTo({ top: 0, behavior: "smooth" });
          },
          generateQuery: function () {
            var t = window.location.href.split("?"),
              e = [];
            if (2 != t.length) return e;
            for (var a = t[1].split("&"), r = 0; r < a.length; r++) {
              var i = a[r].split("=");
              e[i[0]] = i[1];
            }
            return e;
          },
          getTagName: function (e) {
            return (
              t.helpers().handleize(e.getAttribute("data-tag")) ||
              t.helpers().handleize(e.textContent).trim()
            );
          },
          basicSearch: function (e, a) {
            var r = !1;
            return (
              (a = (a = a.map((t) => t.toLowerCase())).map(function (e) {
                return t.helpers().handleize(e);
              })),
              "object" == typeof e
                ? Object.keys(e).forEach(function (t) {
                    if (a.indexOf(e[t]) > -1) return (r = !0), !1;
                  })
                : [e].forEach(function (t) {
                    Object.keys(t).forEach(function (e) {
                      if (a.indexOf(t[e]) > -1) return (r = !0), !1;
                    });
                  }),
              r
            );
          },
          basicTagSearch: function (e, a) {
            return !!a.tags && t.helpers().basicSearch(e, a.tags);
          },
          productTagFilter: function (e, a) {
            var r = !0;
            return (
              Object.keys(e).forEach(function (i) {
                return (
                  r &&
                    e[i] &&
                    e[i].length &&
                    (r =
                      r &&
                      (t.customFilters[i]
                        ? t.customFilters[i](e[i], a)
                        : t.helpers().basicTagSearch(e[i], a))),
                  r
                );
              }),
              r
            );
          },
          compareRanges: function (t, e) {
            for (var a = 0; a < e.length; a++)
              if (t >= e[a][0] && t <= e[a][1]) return !0;
            return !1;
          },
          formatMoney: function (t, e) {
            "string" == typeof t && (t = t.replace(".", ""));
            var a = "",
              r = /\{\{\s*(\w+)\s*\}\}/,
              i = e || "₹{{amount_no_decimals}}";
            function s(t, e, a, r) {
              if (((a = a || ","), (r = r || "."), isNaN(t) || null === t))
                return 0;
              var i = (t = (t / 100).toFixed(e)).split(".");
              return (
                i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
                (i[1] ? r + i[1] : "")
              );
            }
            switch (i.match(r)[1]) {
              case "amount":
                a = s(t, 2);
                break;
              case "amount_no_decimals":
                a = s(t, 0);
                break;
              case "amount_with_comma_separator":
                a = s(t, 2, ".", ",");
                break;
              case "amount_no_decimals_with_comma_separator":
                a = s(t, 0, ".", ",");
                break;
              case "amount_no_decimals_with_space_separator":
                a = s(t, 0, " ");
                break;
              case "amount_with_apostrophe_separator":
                a = s(t, 2, "'");
            }
            return i.replace(r, a);
          },
          slideToggle: function (t, e = 300) {
            return "none" === window.getComputedStyle(t).display
              ? (function (t, e = 500) {
                  t.style.removeProperty("display");
                  let a = window.getComputedStyle(t).display;
                  "none" === a && (a = "block"), (t.style.display = a);
                  let r = t.offsetHeight;
                  (t.style.overflow = "hidden"),
                    (t.style.height = 0),
                    (t.style.paddingTop = 0),
                    (t.style.paddingBottom = 0),
                    (t.style.marginTop = 0),
                    (t.style.marginBottom = 0),
                    t.offsetHeight,
                    (t.style.boxSizing = "border-box"),
                    (t.style.transitionProperty = "height, margin, padding"),
                    (t.style.transitionDuration = e + "ms"),
                    (t.style.height = r + "px"),
                    t.style.removeProperty("padding-top"),
                    t.style.removeProperty("padding-bottom"),
                    t.style.removeProperty("margin-top"),
                    t.style.removeProperty("margin-bottom"),
                    window.setTimeout(function () {
                      t.style.removeProperty("height"),
                        t.style.removeProperty("overflow"),
                        t.style.removeProperty("transition-duration"),
                        t.style.removeProperty("transition-property");
                    }, e);
                })(t, e)
              : (function (t, e = 500) {
                  (t.style.transitionProperty = "height, margin, padding"),
                    (t.style.transitionDuration = e + "ms"),
                    (t.style.boxSizing = "border-box"),
                    (t.style.height = t.offsetHeight + "px"),
                    t.offsetHeight,
                    (t.style.overflow = "hidden"),
                    (t.style.height = 0),
                    (t.style.paddingTop = 0),
                    (t.style.paddingBottom = 0),
                    (t.style.marginTop = 0),
                    (t.style.marginBottom = 0),
                    window.setTimeout(function () {
                      (t.style.display = "none"),
                        t.style.removeProperty("height"),
                        t.style.removeProperty("padding-top"),
                        t.style.removeProperty("padding-bottom"),
                        t.style.removeProperty("margin-top"),
                        t.style.removeProperty("margin-bottom"),
                        t.style.removeProperty("overflow"),
                        t.style.removeProperty("transition-duration"),
                        t.style.removeProperty("transition-property");
                    }, e);
                })(t, e);
          },
        };
      }),
      (o.prototype.initCustomFilters = function () {
        var t = this;
        return {
          availability: function (t, e) {
            var a = !1;
            return (
              t.filter(function (t) {
                "in-stock" == t && e.available && (a = !0),
                  "out-of-stock" != t || e.available || (a = !0);
              }),
              a
            );
          },
          brand: function (e, a) {
            var r = !1;
            return (
              e.filter(function (e) {
                a.vendor &&
                  t.helpers().handleize(e) == t.helpers().handleize(a.vendor) &&
                  (r = !0);
              }),
              r
            );
          },
          size: function (e, a) {
            var r = !1;
            return (
              e.filter(function (e) {
                a.variants.forEach(function (a) {
                  ((a.option1 &&
                    t.helpers().handleize(e) ==
                      t.helpers().handleize(a.option1)) ||
                    (a.option2 &&
                      t.helpers().handleize(e) ==
                        t.helpers().handleize(a.option2)) ||
                    (a.option3 &&
                      t.helpers().handleize(e) ==
                        t.helpers().handleize(a.option3))) &&
                    (r = !0);
                });
              }),
              r
            );
          },
          color: function (e, a) {
            var r = !1;
            return (
              e.filter(function (e) {
                a.variants.forEach(function (a) {
                  ((a.option1 &&
                    t.helpers().handleize(e) ==
                      t.helpers().handleize(a.option1)) ||
                    (a.option2 &&
                      t.helpers().handleize(e) ==
                        t.helpers().handleize(a.option2)) ||
                    (a.option3 &&
                      t.helpers().handleize(e) ==
                        t.helpers().handleize(a.option3))) &&
                    (r = !0);
                });
              }),
              r
            );
          },
          Price: function (e, a) {
            var r = !1,
              i = [];
            return (
              e.filter(function (e) {
                i.push(e.split("-")),
                  t.helpers().compareRanges(a.price / 100, i) && (r = !0);
              }),
              r
            );
          },
          producttype: function (e, a) {
            var r = !1;
            return (
              e.filter(function (e) {
                a.type &&
                  t.helpers().handleize(e) == t.helpers().handleize(a.type) &&
                  (r = !0);
              }),
              r
            );
          },
        };
      }),
      (o.prototype.htmlRenderer = function () {
        var t = this;
        return {
          renderProduct: function (t, e) {
            let uniqueIndex = t;
            var a = "";
            let loading = "";
            coun += 1;
            coun < 5 ? (loading = "eager") : (loading = "lazy");
            // Handle featured image
            if (e.featured_image) {
              var r = e.featured_image.split(".");
              r[r.length - 2] = r[r.length - 2] + "_360x";
              var i = r.join(".");
            }

            // Begin building product card with Borosil structure
            a += `<borosil-product-card
              data-selector="product-card"
              data-view="${window.currentView}"
              data-section-id="${e.id}-${e.handle}"
              class="product-card tw-relative bmd:tw-block"
              data-page="${t}"
              id="${e.id}"
              
              data-product-variant-handle="${e.handle}"
              data-product-card="true">`;

            // Product image section
            a += `<div class="tw-isolate tw-relative   ${
              window.currentView == "single" ? "tw-w-full" : ""
            }">
              <div class="tw-overflow-hidden ${
                window.currentView == "single" ? "tw-p-4" : "tw-p-0"
              } tw-bg-[#f7f7f7]">
                <div class="tw-relative  ${
                  window.currentView == "single"
                    ? "tw-flex bmd:tw-flex-col"
                    : ""
                }">
                  <a href="/products/${
                    e.handle
                  }" class="tw-w-full primary-image-wrapper ${
              window.currentView == "single" ? "single" : "grid"
            }">
                    <img class="product-card__image" src="${i}" alt="${
              e.title
            }" width="360" height="360" loading="${loading}">
                  </a>`;
            // Product badges
            if (window.currentView == "grid") {
              if (
                e.tags &&
                !e.tags.includes("personalise") &&
                Array.isArray(e.tags) &&
                e.tags.length
              ) {
                for (let i = 0; i < e.tags.length; i++) {
                  let tag = e.tags[i];
                  if (tag.includes("badge__")) {
                    tag = tag.split("badge__")[1];
                    a += `<div class="product-tag badge--top-left">${tag}</div>`;
                  }
                }
              }

              a += `</div>
          </div>`;
              if (
                e.tags.includes("personalise") &&
                Array.isArray(e.tags) &&
                e.tags.length
              ) {
                a +=
                  '<div class="product-tag product-tag-personalise badge--top-left">Personalise</div>';
              }

              a += `</div>
          </div>`;
            }

            // Product Variants - size
            if (window.currentView == "grid") {
              if (e.product_variants_size.length == 0) {
                // Marmeto Variants
                const hasRealVariant = e.variants.some(
                  (variant) => variant.title !== "Default Title"
                );

                a += `
                  <div class="product-card__variants tw-min-w-full tw-min-h-[4.5rem]">
                    <marmeto-variants        
                      id="marmeto-variants-${e.id}"
                      class="marmeto-variants"
                      data-section-id=""
                      data-product-handle=""
                      data-product-id=""
                    >
                      <div class="product-form__input product-form__input--dropdown">
                        <div class="product-form__select select  ${
                          e.variants.length > 1 ? "more-than-one-variant" : ""
                        }">
                          <select
                            id="Option-${e.id}"
                            class="select__select tw-relative tw-w-full ${
                              hasRealVariant
                                ? "tw-bg-[#f1f1f1]"
                                : "tw-bg-[#f7f7f7]"
                            } tw-text-[1.6rem] bmd:tw-text-[1.2rem] tw-font-primary tw-text-[#4A4A4A]"
                            name="options[Size]"
                            form="product-form--template--${e.id}"
                            ${
                              e.variants.filter(
                                (v) => v.title !== "Default Title"
                              ).length === 1
                                ? "disabled"
                                : ""
                            }
                          >
                `;

                e.variants.forEach((variant) => {
                  if (variant.title === "Default Title") return;
                  const variantData = JSON.stringify({
                    id: variant.id,
                    title: variant.title,
                    handle: variant.handle,
                    published_at: variant.published_at,
                    created_at: variant.created_at,
                    vendor: variant.vendor,
                    type: variant.type,
                    tags: variant.tags,
                    price: variant.price,
                    price_min: variant.price_min,
                    price_max: variant.price_max,
                    available: variant.available,
                    price_varies: variant.price_varies,
                    compare_at_price: variant.compare_at_price,
                    compare_at_price_min: variant.compare_at_price_min,
                    compare_at_price_max: variant.compare_at_price_max,
                    compare_at_price_varies: variant.compare_at_price_varies,
                    variants: variant.variants,
                    images: variant.images,
                    featured_image: variant.featured_image,
                    options: variant.options,
                    media: variant.media,
                    requires_selling_plan: variant.requires_selling_plan,
                    selling_plan_groups: variant.selling_plan_groups,
                    content: variant.content,
                  });

                  a += `
                    <option 
                      value='${variantData}'
                      data-product-handle="${variant.handle}" 
                      data-section-id="${t.sectionId}" 
                      data-product-id="${e.id}" 
                      data-product-card="true"
                      ${variant.id === e.id ? 'selected="selected"' : ""}
                    >
                      ${variant.title}${!variant.available ? " - Sold out" : ""}
                    </option>
                
                    <script type="application/json" class="variant-data">
                      ${variantData}
                    </script>
                    <script data-variant-holder type="application/json">
                      ${variantData}
                    </script>
                  `;
                });

                a += `
                          </select>
                         
                        </div>
                      </div>
                    </marmeto-variants>
                  </div>
                `;
              } else {
                const hasRealVariant = e.variants.some(
                  (variant) => variant.title !== "Default Title"
                );

                a += `<div class="product-card__variants tw-min-w-full tw-min-h-[4.5rem]">                
                <product-variants data-template="" data-cart-product="" data-item-key="" data-variant-id="">
                  <div class="product-form__input product-form__input--dropdown">
                    <div class="product-form__select select ${
                      e.product_variants_size.length > 1
                        ? "more-than-one-variant"
                        : ""
                    }">
                      <select id="Option-${
                        e.id
                      }" class="select__select tw-relative tw-w-full ${
                  hasRealVariant ? "tw-bg-[#f1f1f1]" : "tw-bg-[#f7f7f7]"
                } tw-text-[1.6rem] bmd:tw-text-[1.2rem] tw-font-primary tw-text-[#4A4A4A]" name="options-${
                  e.id
                }" form="product-form--template--${e.id}"
                  ${e.product_variants_size.length === 1 ? "disabled" : ""}
                >`;

                // Add variant options
                e.product_variants_size.forEach((variant) => {
                  if (variant.title === "Default Title") return;
                  const variantData = {
                    id: variant.id,
                    title: variant.title,
                    handle: variant.handle,
                    published_at: variant.published_at,
                    created_at: variant.created_at,
                    vendor: variant.vendor,
                    type: variant.type,
                    tags: variant.tags,
                    price: variant.price,
                    price_min: variant.price_min,
                    price_max: variant.price_max,
                    available: variant.available,
                    price_varies: variant.price_varies,
                    compare_at_price: variant.compare_at_price,
                    compare_at_price_min: variant.compare_at_price_min,
                    compare_at_price_max: variant.compare_at_price_max,
                    compare_at_price_varies: variant.compare_at_price_varies,
                    variants: variant.variants,
                    images: variant.images,
                    featured_image: variant.featured_image,
                    options: variant.options,
                    media: e.media,
                    requires_selling_plan: e.requires_selling_plan,
                    selling_plan_groups: e.selling_plan_groups,
                    content: e.content,
                  };

                  const variantJson = JSON.stringify(variantData).replace(
                    /</g,
                    "\\u003c"
                  ); // escape < to prevent HTML parse issues

                  a += `<option value="${variant.id}"
                  data-product-handle="${variant.handle}" 
                  data-section-id="${t.sectionId}" 
                  data-product-id="${e.id}" 
                  data-product-card="true"
                  ${variant.id === e.id ? 'selected="selected"' : ""}>
                  ${variant.option_array
                    .filter((opt) => opt.name.toLowerCase() === "size")
                    .map((opt) => opt.values[0])
                    .join(" ")}${!variant.available ? " - Sold out" : ""}
                </option>
                <script type="application/json" class="variant-data">
                   ${variantJson}
                </script>`;
                });

                a += `</select>
                    
                    </div>
                  </div>
                </product-variants>
              </div>`;
              }
            }
            // Product info section
            a += `<div class="product-card__info tw-min-h-[15rem] tw-relative tw-z-[0] go-behind tw-bg-[#f7f7f7] tw-py-[8px] tw-px-[12px] md:tw-py-[1.1rem] md:tw-px-[17px]">`;

            // Product title
            a += `<a href="/products/${e.handle}" class="product-card__title ${
              window.currentView == "single" ? "horizontal" : "vertical"
            } tw-inline-block tw-overflow-hidden">
              <span class="product__card__title tw-min-h-[4.8rem] bmd:tw-min-h-[4rem] ${
                window.currentView == "single" ? "horizontal" : "vertical"
              } tw-text-[16px] tw-text-[#4a4a4a] bmd:tw-text-[1.4rem]">
                ${e.title}
              </span>
            </a>`;

            if (
              window.currentView == "single" &&
              e.product_variants_color.length > 0
            ) {
              // Color Variants
              a += `
                <div class="product-card__variants product-card__variants-plp tw-min-w-full tw-min-h-[4.5rem]">
                  <p>Color</p>    
                  <div class="mm-product-variant-wrapper product__color__variants">
                  
                    <product-variants class="horizontal-color-variants" data-product-variant-handle="${e.handle}" data-product-card="true" data-section-id="${t.sectionId}" data-product-id="${e.id}">
              `;

              e.product_variants_color.forEach((variant, index) => {
                const variantData = JSON.stringify({
                  id: variant.id,
                  title: variant.title,
                  handle: variant.handle,
                  published_at: variant.published_at,
                  created_at: variant.created_at,
                  vendor: variant.vendor,
                  type: variant.type,
                  tags: variant.tags,
                  price: variant.price,
                  price_min: variant.price_min,
                  price_max: variant.price_max,
                  available: variant.available,
                  price_varies: variant.price_varies,
                  compare_at_price: variant.compare_at_price,
                  compare_at_price_min: variant.compare_at_price_min,
                  compare_at_price_max: variant.compare_at_price_max,
                  compare_at_price_varies: variant.compare_at_price_varies,
                  variants: variant.variants,
                  images: variant.images,
                  featured_image: variant.featured_image,
                  options: variant.options,
                  media: e.media,
                  requires_selling_plan: e.requires_selling_plan,
                  selling_plan_groups: e.selling_plan_groups,
                  content: e.content,
                });
                if (variant.title === "Default Title") return;
                a += `    
                  <input
                    type="radio"
                    name="product-as-variants-color"
                    id="color-${variant.id}-${e.id}-${uniqueIndex}"
                    value='${variant.id}'
                    ${variant.id === e.id ? "checked" : ""}
                    ${!variant.available ? "disabled" : ""}
                    data-unique-id="${uniqueIndex}"
                    data-product-handle="${variant.handle}"
                    data-section-id="${t.sectionId}"
                    data-product-id="${e.id}"
                    data-product-card="true"
                    data-variant-id="${variant.id}"
                    class="tw-hidden variant-radio"
                  >
                  <script data-variant-holder type="application/json">
                    ${variantData}
                  </script>
                    <script type="application/json" data-index="${index}" class="variant-data">
                    ${variantData}
                  </script>
                  <label
                    for="color-${variant.id}-${e.id}-${uniqueIndex}"
                    data-variant-id="${variant.id}"
                    class="product-as-variants-color-label color-${uniqueIndex}  ${
                  variant.id === e.id ? "checked" : ""
                } ${
                  !variant.available ? "disabled" : ""
                }  product__color__variant tw-border tw-rounded tw-px-3 tw-py-1 ${
                  !variant.available ? "disabled-variant" : ""
                }"
                  >
                   <div class="tw-w-full tw-h-full"> <img src="${
                     variant.featured_image
                   }" width="70" height="70" /></div>
                  </label>
                `;
              });

              a += `</product-variants>
        </div></div>`;
            }

            if (window.currentView == "single") {
              // Size Variants for Horizontal card - fallback
              if (e.product_variants_size.length == 0) {
                a += `
                <div class="product-card__variants product-card__variants-plp tw-min-w-full tw-min-h-[4.5rem]">
                  <div class="mm-product-variant-wrapper">
              `;

                e.variants.forEach((variant) => {
                  const variantData = JSON.stringify({
                    ...variant,
                    handle: e.handle,
                    title: e.title,
                    price: e.price,
                    compare_at_price: e.compare_at_price,
                    available: e.available,
                  });
                  if (variant.title === "Default Title") return;
                  a += `
                  <marmeto-variants
                    id="marmeto-variants-${e.id}"
                    class="marmeto-variants-horizontal product-form__input"
                    data-section-id="${t.sectionId}"
                    data-product-handle="${e.handle}"
                    data-product-id="${e.id}"
                  >
                    <input
                      type="radio"
                      name="product-as-variants-${e.id}"
                      id="variant-${variant.id}"
                      value='${variantData}'
                      ${variant.id === e.selectedVariant.id ? "checked" : ""}
                      ${!variant.available ? "disabled" : ""}
                      data-product-handle="${variant.handle}"
                      data-section-id="${t.sectionId}"
                      data-product-id="${variant.id}"
                      data-product-card="true"
                      data-variant-id="${variant.id}"
                      class="tw-hidden variant-radio"
                    >
                      <script type="application/json" class="variant-data">
                  ${variantData}
                </script>
                    <script data-variant-holder type="application/json">
                      ${variantData}
                    </script>
                    <label
                      for="variant-${variant.id}"
                      class="tw-rounded tw-px-3 tw-py-1 ${
                        !variant.available ? "disabled-variant" : ""
                      }"
                    >
                      ${variant.title}
                    </label>
                  </marmeto-variants>
                `;
                });

                a += `</div></div>`;
              } else {
                // Size Variants (Capacity)

                a += `
                 <div class="product-card__variants product-card__variants-plp tw-min-w-full tw-min-h-[4.5rem]">
                <div class="mm-product-variant-wrapper">   
              `;
                a += `<product-variants class="horizontal-size-variants">`;
                e.product_variants_size.forEach((variant, index) => {
                  const variantData = JSON.stringify({
                    ...variant,
                    handle: e.handle,
                    title: e.title,
                    price: variant.price,
                    compare_at_price: variant.compare_at_price,
                    available: variant.available,
                  });

                  if (variant.title === "Default Title") return;
                  const sizeText = variant.option_array
                    .filter((opt) => opt.name.toLowerCase() === "size")
                    .map((opt) => opt.values[0])
                    .join(" ");

                  a += `
                  <input
                    type="radio"
                    name="product-as-variants"
                    data-unique-index = "${uniqueIndex}"
                    id="variant-${variant.id}-${e.id}-${uniqueIndex}"
                    value="${variant.id}"
                    ${variant.id == e.id ? "checked" : ""}
                    ${!variant.available ? "disabled" : ""}
                    data-product-handle="${variant.handle}"
                    data-section-id="${t.sectionId}"
                    data-product-id="${e.id}"
                    data-product-card="true"
                    data-available="${e.available}"
                    data-variant-id="${variant.id}"
                    class="tw-hidden variant-radio"
                  ><script type="application/json" class="variant-data" data-variant-id="${variant.id}">${variantData}</script>
                  <label
                  data-variant-id="${variant.id}"
                    for="variant-${variant.id}-${e.id}-${uniqueIndex}"
                    class="product-as-variants-label size-${uniqueIndex} ${
                    !variant.available ? "disabled-variant tw-line-through" : ""
                  } ${variant.id == e.id ? "checked" : ""}" 
                  >
                    ${sizeText}${!variant.available ? " - Sold out" : ""}
                  </label>
                `;
                  ``;
                });
                a += `</product-variants>`;
                a += `</div></div>`;
              }
            }

            // Price section
            if (window.currentView == "grid") {
              a += `<div id="price--${t.sectionId}--${e.id}" class="tw-pt-[0.6rem] md:tw-pt-[0.8rem] tw-flex tw-gap-[0.4rem] tw-whitespace-nowrap">`;

              // Main price
              a += `<span class="h3 tw-text-[#4A4A4A] tw-text-[1.6rem] bmd:tw-text-[1.2rem] tw-font-bold">
          ${Shopify.formatMoney(e.selectedVariant.price, moneyFormat)}
        </span>`;

              // Compare price and discount
              if (
                e.selectedVariant.compare_at_price > e.selectedVariant.price
              ) {
                a += `<span class="tw-line-through compare-at-price tw-text-[1.4rem] bmd:tw-text-[1rem] tw-font-normal tw-text-[#9A9A9A] h3">
            ${Shopify.formatMoney(
              e.selectedVariant.compare_at_price,
              moneyFormat
            )}
          </span>`;

                const discount = parseInt(
                  ((e.selectedVariant.compare_at_price -
                    e.selectedVariant.price) /
                    e.selectedVariant.compare_at_price) *
                    100
                );
                a += `<span class="tw-text-[#44AA00] tw-text-[1.4rem] bmd:tw-text-[1rem] tw-font-normal h3">
            ${discount}% OFF
          </span>`;
              }
              a += `</div>`;
            } else {
              // Price section
              a += `<div class="tw-flex tw-w-full tw-justify-between tw-items-center horizontal-price-section">`;
              a += `<div id="price--${t.sectionId}--${e.id}" class="price-single tw-pt-[0.6rem] md:tw-pt-[0.8rem] tw-flex  tw-gap-[0.4rem] tw-whitespace-nowrap">`;
              // Compare price and discount
              if (
                e.selectedVariant.compare_at_price > e.selectedVariant.price
              ) {
                a += `<span class="">
            
              <span class="tw-text-[2rem] selling-price  bmd:tw-text-[1.4rem] tw-font-bold tw-text-[#4a4a4a] h3">
             ${Shopify.formatMoney(e.selectedVariant.price, moneyFormat)}</span>
            </span>`;
                const discount = parseInt(
                  ((e.selectedVariant.compare_at_price -
                    e.selectedVariant.price) /
                    e.selectedVariant.compare_at_price) *
                    100
                );
                a += `<div>
                 <span class="h3 tw-text-[#9a9a9a] tw-text-[1.4rem] bmd:tw-text-[1.2rem]  tw-leading-tight tw-font-normal  tw-line-through compare-at-price"> ${Shopify.formatMoney(
                   e.selectedVariant.compare_at_price,
                   moneyFormat
                 )}</span> 
              <span class="tw-text-[#44AA00] discount-percentage tw-text-[1.2rem]  tw-font-normal h3">
                ${discount}% OFF
              </span>
            </div> `;
              } else {
                a += `<div><span class="h3 tw-text-[#4A4A4A] tw-text-[1.8rem] md:tw-text-[2.4rem] tw-leading-tight tw-font-bold selling-price">
              ${Shopify.formatMoney(
                e.selectedVariant.price,
                moneyFormat
              )}</span></div>`;
              }
              a += `</div>`;
              if (!e.tags.includes("personalise")) {
                a += `<product-form class="${
                  e.product_variants_color.length === 0
                    ? "tw-w-full tw-flex tw-justify-end"
                    : ""
                }">
                  <form method="post" action="/cart/add" id="product-form--${
                    t.sectionId
                  }--${e.id}" 
                        accept-charset="UTF-8" class="form" enctype="multipart/form-data" 
                        novalidate="novalidate" data-type="add-to-cart-form">
                    
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${
                      e.selectedVariant.id
                    }">
                    
                    ${
                      !e.selectedVariant.available
                        ? `<div class="sold-out-text tw-text-[1.4rem] tw-font-medium tw-text-[#9A9A9A]">Sold Out</div>`
                        : `<button id="product-form--${t.sectionId}--${e.id}-submit" 
                            type="submit" 
                            name="add" 
                            class="quick-add__submit product-card--btn tw-bg-transparent tw-relative card--horizontal__quick-add" 
                            aria-haspopup="dialog" 
                            aria-labelledby="product-form--${t.sectionId}--${e.id}-submit title-${t.sectionId}-${e.id}" 
                            aria-live="polite" 
                            aria-disabled="false"
                            data-sold-out-message="true">
                            
                      <span class="add-cart--icon tw-z-[-1]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
                          <path d="M8.57535 10.1143V4.94485C9.05154 0.71532 14.2896 1.65526 14.2896 4.94485V10.1143" stroke="#4A4A4A" stroke-width="1.25714"></path>
                          <path d="M2.91818 7.65714H19.9468V16.6794C19.9468 18.5764 18.4089 20.1143 16.5118 20.1143H6.35311C4.45605 20.1143 2.91818 18.5764 2.91818 16.6794V7.65714Z" stroke="#4A4A4A" stroke-width="1.25714"></path>
                        </svg>
                      </span>
                      <div class="loading-overlay__spinner tw-top-0 tw-left-[1rem] hidden">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </button>`
                    }
                
                    <input type="hidden" name="product-id" value="${e.id}">
                    <input type="hidden" name="section-id" value="${
                      t.sectionId
                    }">
                  </form>
                </product-form>`;

                a += `</div>`;

                // Error message wrapper
                a += `<div class="product-form__error-message-wrapper" role="alert" hidden="">
          <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
            <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
            <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
          </svg>
          <span class="product-form__error-message"></span>
        </div>`;
              } else {
                a += `<a href=${e.url}  class="${
                  e.product_variants_color.length === 0
                    ? "tw-w-full tw-flex tw-justify-end"
                    : ""
                }"> <svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  width="24"
  height="24"
  viewBox="0 0 24 24"

>
  <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAz5JREFUSEvtlU1oFVcUx/9nMv16E7CtLaERtIqLVqFQYtNCKHlCJe/OvJca9EmxSj+CX8WFi27aRQkUW1EUxE0VRBBU6NiKk5l7QwwaIiEtggqCpVQN3YiKKGqGlJfMHHPDTJg88xI3rurdDPfjnN85/3vOHcIzHvSM/eN/AMjn8/W5XK4MYAWARcxcIaJrAAYsy1Ku60azyVxTonK5/GIYhl0AdgB4JXFyBcA8AAuT+S0A30spj9SCzAgQQiwzDOM0M2tHPzPzQBRFf/b29obaUUdHx/xKpdISx7FDRJsB9DHzGqXUw2rQE4BCofAeEZ0lonsA1kgpddQ1h+M47cx8FMBwXV3dqu7u7rvZw9MAbW1tyycODQLoNU2z0/O8R+lhLdnIyMhyIgqbm5uvdXV1xeleqVRaPD4+ftIwjJcAfBwEwf10bwrQ3t7eODY2doGIBqWU67JROI7zLTP/CODlZP0OEX0dBEGQgeSiKPoDQGhZVqvruhW9NwWwbfssM88bHR1t6e/v/y8bXRRFumqGmPkQgDeJaAuAnGVZi7JVVCgU3jYM4xIRHQiC4IcpQKLj7wDer9bccZwNWmPTNN/yPO+2NhJCrCaiU8y8VCl1PZutEGKTBpimucTzvJuTGTiOszOO4y/r6+sXp6mlRrZtb9WVZFnWG2m0pVLpnSiK/jIMo8n3/YtZQLFYXBjH8d+GYaz3ff9UCniNmYeJaE8QBDur9P+Emc8A+FxKebxcLteFYbhb90elUnm9r6/vQVUGp4moUUr5wbQ7SFI7COAzKeWvGSOybfscgFYA/yaN9urEhe+SUn6XdW7b9j4A2+M4bunp6bkwDaAntm3v1ZER0Y4gCA6kxk1NTS80NDRsT5yDmW8opXTtT458Pm/mcrn9AL4BsFZK+dsTZZos6GgPT0T6FYATlmV1uq47WrvNgGKxuCCO45MAPgKwTUr5S81GSyGO4xxk5k0A9EV+6vv+PzNBhBCtRKSrT9/hRqXUsepzNR87IUSJiH4CsAyAru0h/YLqXgHQAuBDAO9OfFXy4F2eKYi5fjgkhFhJRF8A0FWhHz/dobrxzjPzYaXU1dkknAswm+1T7T0HzCnTYwSfRSjWvD5JAAAAAElFTkSuQmCC" x="0" y="0" width="24" height="24"/>
</svg></a>`;
              }

              a += `</div>`;
            }

            // Color Variants and ATC Buttons.
            a += `<div class="tw-flex ${
              e.metafields.product_variant_color !== null &&
              e.metafields.plp_color !== null
                ? "tw-justify-between"
                : "tw-justify-end"
            } tw-items-center">`;
            if (
              window.currentView !== "single" &&
              e.product_variants_color &&
              e.product_variants_color.length > 0 &&
              e.metafields &&
              e.metafields.plp_color !== null
            ) {
              a += `<product-variants class="item-swatch tw-flex tw-gap-2 tw-flex-wrap">`;

              e.product_variants_color.forEach((product_variant, index) => {
                const variantData = JSON.stringify({
                  id: product_variant.id,
                  title: product_variant.title,
                  handle: product_variant.handle,
                  published_at: product_variant.published_at,
                  created_at: product_variant.created_at,
                  vendor: product_variant.vendor,
                  type: product_variant.type,
                  tags: product_variant.tags,
                  price: product_variant.price,
                  price_min: product_variant.price_min,
                  price_max: product_variant.price_max,
                  available: product_variant.available,
                  price_varies: product_variant.price_varies,
                  compare_at_price: product_variant.compare_at_price,
                  compare_at_price_min: product_variant.compare_at_price_min,
                  compare_at_price_max: product_variant.compare_at_price_max,
                  compare_at_price_varies:
                    product_variant.compare_at_price_varies,
                  variants: product_variant.variants,
                  images: product_variant.images,
                  featured_image: product_variant.featured_image,
                  options: product_variant.options,
                  media: e.media,
                  requires_selling_plan: e.requires_selling_plan,
                  selling_plan_groups: e.selling_plan_groups,
                  content: e.content,
                });

                const uniqueId = `${e.id}-${index}`; // Ensure unique ID

                const swatchColor = product_variant.color_code;

                a += `
                  <input
                    type="radio"
                    name="color-${e.id}"
                    class="product__variant__swatches__input tw-hidden"
                    id="color-${product_variant.id}-${uniqueId}"
                    value='${variantData.id}'
                    ${product_variant.id === e.id ? "checked" : ""}
                    ${!product_variant.available ? "disabled" : ""}
                    data-product-handle="${product_variant.handle}"
                    data-section-id="${t.sectionId}"
                    data-product-id="${product_variant.id}"
                    data-variant-id="${product_variant.id}"
                    data-color-swatch="true"
                  >
                    <script type="application/json" class="variant-data">
                    ${variantData}
                  </script>
              <label
  for="color-${product_variant.id}-${uniqueId}"
  class="product__color__variant__swatch color
    ${product_variant.available ? "tw-cursor-pointer" : "tw-cursor-not-allowed"}
    ${product_variant.id === e.id ? "checked" : ""}
    tw-border tw-border-[#1212121a] tw-flex tw-items-center
    !tw-p-[0.2rem] !tw-rounded-full tw-w-auto tw-h-auto
    tw-max-w-[1.8rem] tw-max-h-[1.8rem]"
>
                 <span
          class="tw-w-[1.2rem] tw-h-[1.2rem] tw-block tw-rounded-full"
          data-value="${swatchColor}"
          style="background-color: ${swatchColor};"
        ></span>
                  </label>
                `;
              });

              a += `</product-variants>`;
            }

            // Vertical Product card
            if (
              window.currentView !== "grid" &&
              e.product_variants_color &&
              e.product_variants_color.length > 0
            ) {
              a += `<div class="product-card__variants product__color__variants">`;
              a += `<product-variants
    data-product-handle="${e.handle}"
                    data-section-id="${t.sectionId}"
                    data-product-id="${e.id}"
                    data-variant-id="${e.id}"
  >

  `;
              a += `</div>`;
            }
            //  Add to Cart button
            if (window.currentView == "grid") {
              if (!e.tags.includes("personalise")) {
                a += `<product-form class="${
                  e.product_variants_color.length === 0
                    ? "tw-w-full tw-flex tw-justify-end"
                    : ""
                }">
                  <form method="post" action="/cart/add" id="product-form--${
                    t.sectionId
                  }--${e.id}" 
                        accept-charset="UTF-8" class="form" enctype="multipart/form-data" 
                        novalidate="novalidate" data-type="add-to-cart-form">
                    
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${
                      e.selectedVariant.id
                    }">
                    
                    ${
                      !e.selectedVariant.available
                        ? `<div class="sold-out-text tw-text-[1.4rem] tw-font-medium tw-text-[#9A9A9A]" >Sold Out</div>`
                        : `<button id="product-form--${t.sectionId}--${e.id}-submit" 
                            type="submit" 
                            name="add" 
                            class="quick-add__submit product-card--btn tw-bg-transparent tw-relative card--horizontal__quick-add" 
                            aria-haspopup="dialog" 
                            aria-labelledby="product-form--${t.sectionId}--${e.id}-submit title-${t.sectionId}-${e.id}" 
                            aria-live="polite" 
                            aria-disabled="false"
                            data-sold-out-message="true">
                            
                      <span class="add-cart--icon tw-z-[-1]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
                          <path d="M8.57535 10.1143V4.94485C9.05154 0.71532 14.2896 1.65526 14.2896 4.94485V10.1143" stroke="#4A4A4A" stroke-width="1.25714"></path>
                          <path d="M2.91818 7.65714H19.9468V16.6794C19.9468 18.5764 18.4089 20.1143 16.5118 20.1143H6.35311C4.45605 20.1143 2.91818 18.5764 2.91818 16.6794V7.65714Z" stroke="#4A4A4A" stroke-width="1.25714"></path>
                        </svg>
                      </span>
                      <div class="loading-overlay__spinner tw-top-0 tw-left-[1rem] hidden">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </button>`
                    }
                
                    <input type="hidden" name="product-id" value="${e.id}">
                    <input type="hidden" name="section-id" value="${
                      t.sectionId
                    }">
                  </form>
                </product-form>`;

                a += `</div>`;

                // Error message wrapper
                a += `<div class="product-form__error-message-wrapper" role="alert" hidden="">
            <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
              <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
              <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
              <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
              <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
            </svg>
            <span class="product-form__error-message"></span>
          </div>`;
              } else {
                a += `<a href=${e.url}  class="${
                  e.metafields.plp_color == null
                    ? "tw-w-full tw-flex tw-justify-end"
                    : ""
                }"> <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
 
  >
    <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAz5JREFUSEvtlU1oFVcUx/9nMv16E7CtLaERtIqLVqFQYtNCKHlCJe/OvJca9EmxSj+CX8WFi27aRQkUW1EUxE0VRBBU6NiKk5l7QwwaIiEtggqCpVQN3YiKKGqGlJfMHHPDTJg88xI3rurdDPfjnN85/3vOHcIzHvSM/eN/AMjn8/W5XK4MYAWARcxcIaJrAAYsy1Ku60azyVxTonK5/GIYhl0AdgB4JXFyBcA8AAuT+S0A30spj9SCzAgQQiwzDOM0M2tHPzPzQBRFf/b29obaUUdHx/xKpdISx7FDRJsB9DHzGqXUw2rQE4BCofAeEZ0lonsA1kgpddQ1h+M47cx8FMBwXV3dqu7u7rvZw9MAbW1tyycODQLoNU2z0/O8R+lhLdnIyMhyIgqbm5uvdXV1xeleqVRaPD4+ftIwjJcAfBwEwf10bwrQ3t7eODY2doGIBqWU67JROI7zLTP/CODlZP0OEX0dBEGQgeSiKPoDQGhZVqvruhW9NwWwbfssM88bHR1t6e/v/y8bXRRFumqGmPkQgDeJaAuAnGVZi7JVVCgU3jYM4xIRHQiC4IcpQKLj7wDer9bccZwNWmPTNN/yPO+2NhJCrCaiU8y8VCl1PZutEGKTBpimucTzvJuTGTiOszOO4y/r6+sXp6mlRrZtb9WVZFnWG2m0pVLpnSiK/jIMo8n3/YtZQLFYXBjH8d+GYaz3ff9UCniNmYeJaE8QBDur9P+Emc8A+FxKebxcLteFYbhb90elUnm9r6/vQVUGp4moUUr5wbQ7SFI7COAzKeWvGSOybfscgFYA/yaN9urEhe+SUn6XdW7b9j4A2+M4bunp6bkwDaAntm3v1ZER0Y4gCA6kxk1NTS80NDRsT5yDmW8opXTtT458Pm/mcrn9AL4BsFZK+dsTZZos6GgPT0T6FYATlmV1uq47WrvNgGKxuCCO45MAPgKwTUr5S81GSyGO4xxk5k0A9EV+6vv+PzNBhBCtRKSrT9/hRqXUsepzNR87IUSJiH4CsAyAru0h/YLqXgHQAuBDAO9OfFXy4F2eKYi5fjgkhFhJRF8A0FWhHz/dobrxzjPzYaXU1dkknAswm+1T7T0HzCnTYwSfRSjWvD5JAAAAAElFTkSuQmCC" x="0" y="0" width="24" height="24"/>
  </svg></a>`;
              }
            }
            a += `</borosil-product-card>`;

            return a;
          },
        };
      }),
      (o.prototype.toggleProductGridView = function () {
        window.isSingleView = false;
        const singleView = document.getElementById("single-view");
        const gridView = document.getElementById("grid-view");
        const productGrid = document.getElementById("js-product-loop");
        const singleIcon = document
          .getElementById("single-view-icon")
          .querySelector("rect");
        const gridIcon = document
          .getElementById("grid-view-icon")
          .querySelectorAll("path");

        // Define grid layout classes for desktop and mobile views
        const gridClasses = {
          desktop: {
            single: "tw-grid-cols-1",
            default: productGrid.dataset.columnsDesktop || "md:tw-grid-cols-3",
          },
          mobile: {
            single: "tw-grid-cols-2",
            default: productGrid.dataset.columnsMobile || "tw-grid-cols-2",
          },
        };

        // Toggle the active class on the view icons
        const toggleActiveClass = (activeElement, inactiveElement) => {
          activeElement.classList.add("active-view");
          inactiveElement.classList.remove("active-view");

          // Update icon stroke colors based on the active view
          if (activeElement === singleView) {
            singleIcon.setAttribute("stroke", "#4a0");
            gridIcon.forEach((path) => path.setAttribute("stroke", "#6D6D6D"));
          } else {
            singleIcon.setAttribute("stroke", "#6D6D6D");
            gridIcon.forEach((path) => path.setAttribute("stroke", "#4a0"));
          }
        };

        // Update the visibility of product cards based on the selected view
        const updateCardsVisibility = (isSingleView) => {
          const items = productGrid.querySelectorAll(".grid__item");
          items.forEach((item) => {
            const gridCard = item.querySelector('[data-type="grid"]');
            const singleCard = item.querySelector('[data-type="single"]');

            // Show or hide cards based on the selected view
            if (gridCard && singleCard) {
              if (isSingleView) {
                gridCard.classList.add("hidden");
                singleCard.classList.remove("hidden");
              } else {
                gridCard.classList.remove("hidden");
                singleCard.classList.add("hidden");
              }
            }
          });
        };

        // Update the product grid layout and view state
        const updateView = (isSingleView) => {
          const { desktop, mobile } = gridClasses;

          if (isSingleView) {
            // Apply single view layout classes
            productGrid.classList.add(desktop.single, mobile.single);
            productGrid.classList.remove(desktop.default, mobile.default);
            productGrid.classList.remove("grid-view-active");
          } else {
            // Apply grid view layout classes
            productGrid.classList.remove(desktop.single, mobile.single);
            productGrid.classList.add(desktop.default, mobile.default);
            productGrid.classList.add("grid-view-active");
          }

          // Update the data-view attribute to reflect the current view
          productGrid.dataset.view = isSingleView ? "single" : "grid";

          // Update the visibility of product cards
          updateCardsVisibility(isSingleView);
        };

        // Handle DOM changes (e.g., new cards loaded by infinite scroll)
        const handleDOMChanges = (mutations) => {
          const isSingleView = productGrid.dataset.view === "single";
          mutations.forEach((mutation) => {
            if (
              mutation.type === "childList" &&
              mutation.addedNodes.length > 0
            ) {
              updateCardsVisibility(isSingleView);
            }
          });
        };

        // Set up a MutationObserver to watch for changes in the product grid
        const observer = new MutationObserver(handleDOMChanges);
        observer.observe(productGrid, { childList: true, subtree: true });

        // Event listener for switching to single view
        singleView.addEventListener("click", () => {
          updateView(true);
          toggleActiveClass(singleView, gridView);
          window.currentView = "single";
          this.getProducts(window.currentPage);
        });

        // Event listener for switching to grid view
        gridView.addEventListener("click", () => {
          updateView(false);
          toggleActiveClass(gridView, singleView);
          window.currentView = "grid";
          this.getProducts(window.currentPage);
        });
      }),
      o
    );
  })()),
  new marmeto.Collection("marmeto-collection-template");

/*--------- footer-hyper-links-functionality ----------*/
let dataValues;

async function getExcelDataAsync() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "https://sheets.googleapis.com/v4/spreadsheets/1NpItHCd_0GVq3zZ4k51W7iLOEaAhXsPFmFpRCCcskR4/values/Internal%20Linking?key=AIzaSyD_m9uaBxBNAe4kI4NZSDUUKCU3ooF0cIk",
      dataType: "json",
      success: function (data) {
        resolve(data.values);
      },
      error: function (error) {
        reject(error);
      },
    });
  });
}

async function fetchDataAppend() {
  try {
    dataValues = await getExcelDataAsync();
    let currentCollection = $("[data-collection-handle]").attr(
        "data-collection-handle"
      ),
      firstvalue = "",
      categoryArray = [],
      textArray = [],
      linkArray = [];

    //get the first row unique heading
    for (let i = 1; i < dataValues.length; i++) {
      if (dataValues[i][0].trim() == currentCollection) {
        if (dataValues[i][1].trim() != firstvalue.trim()) {
          firstvalue = dataValues[i][1].trim();
          categoryArray.push(firstvalue);
        }
      }
    }

    //create and array of each unique array heading
    for (let k = 0; k < categoryArray.length; k++) {
      this["text" + k] = [];
      this["link" + k] = [];
      textArray.push(this["text" + k]);
      linkArray.push(this["link" + k]);
    }

    //for one heading element push 1 array of texts and corresponding 1 array of links
    for (let j = 0; j < categoryArray.length; j++) {
      for (let i = 1; i < dataValues.length; i++) {
        if (dataValues[i][0].trim() == currentCollection) {
          if (dataValues[i][1].trim() == categoryArray[j].trim()) {
            textArray[j].push(dataValues[i][2]);
            linkArray[j].push(dataValues[i][3]);
          }
        }
      }
    }

    //appending the fetched data
    if (textArray.length > 0 && linkArray.length > 0) {
      $(".footer-links__container").show();
      for (let j = 0; j < textArray.length; j++) {
        if (textArray[j].length) {
          let heading = document.createElement("p");
          heading.classList.add("h2");
          heading.innerText = categoryArray[j];
          document.querySelector(".footer-links__wrapper").appendChild(heading);

          for (let i = 0; i < textArray[j].length; i++) {
            let aTag = document.createElement("a");
            let seporatorTag = document.createElement("div");
            seporatorTag.classList.add("pipe");
            aTag.setAttribute("href", linkArray[j][i]);
            aTag.innerText = textArray[j][i];
            seporatorTag.innerText = "|";
            document.querySelector(".footer-links__wrapper").appendChild(aTag);
            if (i != textArray[j].length - 1) {
              document
                .querySelector(".footer-links__wrapper")
                .appendChild(seporatorTag);
            }
          }
        }
      }
    }
  } catch (error) {
    console.log("Error fetching data:", error);
  }
}

fetchDataAppend();

$(() => {
  function toggleStickyFilter() {
    let bigFilterOffset = document.getElementsByClassName(
      "collection-top-filters"
    )[0].offsetTop;
    if (window.pageYOffset > bigFilterOffset) {
      document
        .getElementsByClassName("sticky-collection-top-filters")[0]
        .classList.add("sticky-filter");
    } else
      document
        .getElementsByClassName("sticky-collection-top-filters")[0]
        .classList.remove("sticky-filter");
  }

  $(".faq-question").click(function (e) {
    $.faqOpen = $(this).closest(".faq");
    $.faqOpen.toggleClass("active");
  });

  $(".faq-question").click(function (e) {
    $.faqClose = $(this).closest(".faq");
  });

  $(".read_more_btn").click(function (e) {
    $(".faq-read-more-container").toggleClass("faq-read-more-hidden");
    if ($(".faq-read-more-container").hasClass("faq-read-more-hidden")) {
      $(".read_more_btn").html("View More");
    } else {
      $(".read_more_btn").html("View Less");
    }
  });

  $(".backdrop").click(() => {
    $(".mmc-sort-mobile").removeClass("is--opened");
    $("body").removeClass("no-scroll");
  });
});

$(".filter-group.and").each(function (index, item) {
  if ($(this).find(".filter-item").length < 1) {
    $(this).hide();
  }
});
